import React, {useContext, useEffect} from 'react';
import {AlertsFilterComponent} from '../../../clean-components/alerts-filter/alerts-filter';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';
import {HeaderContext} from '../../../services/header/header.context';

export function AlertFiltersDsk({children}: any) {
    const HeaderService = useContext(HeaderContext);
    // we get the alert id
    const headerConfig = {
        title: 'translation:misc_alert_filter_title',
        backIcon: true,
        closeIcon: false,
        logoIcon: false,
        customClassName: true,
    };

    useEffect(() => {
        if (HeaderService.headerConfig.title != headerConfig.title) {
            HeaderService.initHeader(headerConfig);
        }
    }, [HeaderService.headerConfig]);


    return <DesktopPage config={headerConfig}>
        <AlertsFilterComponent/>
    </DesktopPage>;
}
